export namespace SchoolType {
  export enum Values {
    REAL = 'REAL',
    DUMMY = 'DUMMY'
  }

  export function label(classroomType: Values) {
    switch (classroomType) {
      case Values.REAL:
        return 'Réel'
      case Values.DUMMY:
        return 'Factice'
    }
  }

  export const options = Object.values(Values).map((type) => ({
    value: type,
    label: label(type)
  }))
}
